import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import {
    createPalette,
    PaletteButton,
    PalettePositionMaxHeight,
    PalettePositionWidth,
} from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import type { ButtonProps } from '@gitbook/spine-react';
import { filterOutNullable } from '@gitbook/util-ts';

import { useChangeRequestActionsCommands, useChangeRequestCopyCommands } from './commands';

/**
 * Button to display secondary actions relative to the change request in the context of the change requests listing screen.
 */
export function ChangeRequestMoreButton(
    props: {
        space: api.Space;
        changeRequest: api.ChangeRequest;
    } & Omit<ButtonProps, 'onPress' | 'label'>
): React.ReactElement {
    const { space, changeRequest, ...buttonProps } = props;

    const copyCommands = useChangeRequestCopyCommands({ space, changeRequest });
    const actionsPaletteGroup = useChangeRequestActionsCommands({
        spaceKey: space.id,
        changeRequest,
    });

    return (
        <PaletteButton
            palette={() =>
                createPalette({
                    position: {
                        width: PalettePositionWidth.MEDIUM,
                        maxHeight: PalettePositionMaxHeight.AUTO,
                        preferredPlacement: 'bottom',
                    },
                    groups: [
                        {
                            key: 'changeRequest.utility',
                            commands: [copyCommands],
                        },
                        actionsPaletteGroup,
                    ].filter(filterOutNullable),
                })
            }
            leadingIcon={Icon.MoreVertical}
            label="Change request options"
            kind="blank"
            size="medium"
            iconOnly
            {...buttonProps}
        />
    );
}
